import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import AuthContext from '../../store/AuthContext';
import ClientCredInfo from './ClientCredInfo';
import ClientCredCmd from './ClientCredCmd';
import * as services from '../../services/services';
import * as utils from '../../services/utils';

import '../Main.css';

const authorizeParam = utils.AUTH_INFO;

function ClientCredMain() {
  const iuaCtx = useContext(AuthContext);

  const [validationMsg, setValidationMsg] = useState('');
  
  useEffect(() => {
    sessionStorage.clear();
    iuaCtx.clear();
  }, []);
  
  useEffect(() => {
    handleDisplayCmdData();
  }, [iuaCtx]);

  const history = useHistory();
  
  const iuaConnectProps = {
    handleDisplayCmdData: handleDisplayCmdData
  };

  const iuaCmdProps = {
    buildAuthCmdData: buildAuthCmdData
  };

  function getClientData() {
    const cmdData = iuaConnectProps.getData(); 
    // console.log(cmdData);
    cmdData.reqMethod = utils.HTTP_METHOD.post;    

    let reqHeaders = {};
    reqHeaders[utils.AUTH_HEADER] = utils.AUTH_BASIC_PREFIX + ' ' + cmdData.base64Credentials;
    reqHeaders = {...reqHeaders, ...utils.CT_FORM_HEADER};

    cmdData.reqHeaders = reqHeaders;

    // console.log(cmdData);
    return cmdData;
  }

  function handleDisplayCmdData() {
    const cmdData = getClientData(); 
    // console.log(cmdData);
    iuaCmdProps.displayCmdData(cmdData);
  }

  function handleCloseInfo() {
    iuaConnectProps.handleCloseInfo();
  }

  let authorizeData = '';

  function buildAuthCmdData() {
    authorizeData = getClientData();    

    const reqURL = authorizeData.tokenUri;
    const reqMethod = authorizeData.reqMethod;
    const reqHeaders = authorizeData.reqHeaders;

    const reqParams = {};
    reqParams[authorizeParam.grantType] = utils.CLIENT_CRED_GRANT_TYPE;
    authorizeData.scopes && (reqParams[authorizeParam.scopes] = authorizeData.scopes);

    const reqData = {
      reqURL: reqURL,
      reqMethod: reqMethod,
      reqHeaders: reqHeaders,
      reqParams: reqParams
    }

    // console.log(reqData);
    return reqData;
  }

  async function submitHandler(event) {
    event.preventDefault();
    let result = await iuaConnectProps.trigger();
    if (!result) {
      setValidationMsg('Could not submit the request due to missing or invalid input data. Review the data entered.');
      return;
    } 

    const reqData = buildAuthCmdData();
    // console.log(reqData);
    
    /* Get Token */

    result = await services.getTokenFromAppApi(reqData.reqURL, reqData.reqParams, reqData.reqHeaders); 

    const token = result?.access_token;
    if (token) {
      iuaCtx.setAccessToken(token);
    } else {
      const error = result?.data && utils.objectToString(result?.data);
      error && iuaCtx.setAuthErr(error);
    }

    sessionStorage.setItem('transType', utils.TRANS.client_credentials);

    history.push("/authorize");
  }

  return (
  <div onClick={handleCloseInfo}>
    <div className="container main-body">
      <form className="main-form">
      
        <ClientCredInfo connectData={iuaConnectProps}></ClientCredInfo>

        <div className="row">
          <div className="col-8">
            <ClientCredCmd cmdData={iuaCmdProps}></ClientCredCmd>
          </div>
        </div>

        <div className="row">
          <div className="col-8">
            <div className="main-form-submit validation-msg error">

              {/* VALIDATION MSG */}

              <div>{validationMsg}</div>

            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-7">
            <div className="main-form-submit">

              {/* ACCESS TOKEN */}

              <button onClick={submitHandler} className="btn btn-danger main-form-submit-button"> Send Request 
                {/* <i className="fa fa-paper-plane-o ml-1"></i> */}
              </button>

            </div>
          </div>
        </div>

      </form>
    </div>
  </div>  
  );
}

export default ClientCredMain;
